"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 20a8.968 8.968 0 01-3.658-.774l-5.329.76.761-5.328a9 9 0 1117.01-5.624 7.503 7.503 0 00-6.117 10.564A8.96 8.96 0 019 20zm-6.63-2.37l.466-3.26-.235-.526A7 7 0 0115.13 7.615 9.502 9.502 0 009.119 18L9 18a6.968 6.968 0 01-2.844-.602l-.527-.234-3.259.466z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.992 21.992l-3.257-.465a5.5 5.5 0 112.791-2.791l.466 3.256zm-2.527-3.544l.235-.526a3.5 3.5 0 10-1.778 1.778l.526-.235 1.187.17-.17-1.187z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;